import { useRef } from 'react'

import { Nullable } from '@types'

import { ShortlistSortOrder } from '@modules/shortlist/types'

import { Root } from './SortButton.styles'

interface SortButtonProps {
  className?: string
  isActive: boolean
  order: Nullable<ShortlistSortOrder>
  onClick?: (params: { btnElement: HTMLElement }) => void
}

const SortButton = ({ className, isActive, order, onClick }: SortButtonProps) => {
  const buttonRef = useRef<HTMLDivElement>()

  const handleClick: React.MouseEventHandler<HTMLDivElement> = () => {
    onClick?.({ btnElement: buttonRef.current as HTMLDivElement })
  }

  return <Root ref={buttonRef} className={className} $isActive={isActive} $order={order} onClick={handleClick} />
}

export default SortButton
